/** `includeWatchedRuns` is false for a caller who may not read the agency's workflow runs. */
type Args = { facilityId: number; includeWatchedRuns: boolean };

class FetchWorkingFacilityCounts {
	readonly facilityId: number;
	readonly includeWatchedRuns: boolean;

	constructor(args: Args) {
		this.facilityId = args.facilityId;
		this.includeWatchedRuns = args.includeWatchedRuns;

		Object.freeze(this);
	}
}

export default FetchWorkingFacilityCounts;
